import React from 'react';
import autoBind from 'react-autobind';

import * as Components from '../Components.js';
//import * as Generation from '../Generation.js';
import * as Helpers from '../Helpers.js';

//import {DateObject} from "react-multi-date-picker";

// import SimpleMdeReact from "react-simplemde-editor";
// import "easymde/dist/easymde.min.css";


//import the Darwin API classes
import API from '../API.js';

import ImageClose from '../images/Icons/Close.svg'
// import ImageTrash from '../images/Icons/Trash.svg'
// import ImageMoveUp from '../images/Icons/MoveUp.svg'
// import ImageMoveDown from '../images/Icons/MoveDown.svg'

// import ImageToolbar from '../images/Icons/Toolbar.svg'
// import ImageHeader from '../images/Icons/Header.svg'
// import ImageText from '../images/Icons/Text.svg'
// import ImageImage from '../images/Icons/Image.svg'
// import ImageVideo from '../images/Icons/Video.svg'

// import ImageProfile from '../images/Icons/UserGray.svg'
// import ImageLoading from '../images/Icons/loading.svg'
//import ImageCheckmark from '../images/Icons/Checkmark.svg'
//import ImageUncheckmark from '../images/Icons/Uncheckmark.svg'

export class ManageDisputes extends React.Component {

  constructor(props) {
    super(props)

    let data = {}

    this.state = {
      loading: false,
      data: data,
      forceCheck: false,
      shakeButton: false,
      changesMade: false, //have any changes been made

      view: "Home",
      subview: "Home",
      prompt: false,

      disputes: [],
      nextDispute: false,
      filter: "All", //the filter to apply
      sort: "Published", //the sort to apply
      sortDirection: "DESC", //DESC or ASC
      limit: 100, //the number of results per page.
      page: 0, //the page of results.
      pageMax: 0, //the max page.
      search: "", //the search parameter.
      resultsCount: 0, //the number of results.
      sandbox: false, //sandbox or live results.
      needsResponse: props.tertiaryView ===  "NeedsResponse" ? true : false, //only shows those that need a response.
    }
    autoBind(this)
  }

  componentDidMount() {
    //calculate the view
    this.calculateView()
  }

  componentDidUpdate(prevProps) {
    if (this.props.render !== prevProps.render) {
      //reload the home view.
      this.calculateView()
    }
  }

  calculateView() {
    //set the data
    if (this.state.view === "Home") {
      //load the abilities for this user.
      this.getDisputes()
    }
  }

  /*
  * Submits the form
  */
  submitForm() {
    let results = this.checkForm(true)
    if (results.valid) {
      switch (this.state.view) {
        case "Home":
          this.changeSearch(results.data)
          break;
        default:
          console.error("Unhandled submitForm", this.state.view)
          break;
      }
    } else {
      console.log("Form not valid to submit")
      this.setState({
        forceCheck: true
      })
      //Shake the submit button as it is invalid to submit
      this.shakeTheButton()
    }
  }

  /*
  Checks the form to make sure it is valid.
  Returns {valid:Bool, data:{}}
  */
  checkForm(print = false) {
    //1) Make sure we have all of the data.
    let valid = true
    let requiredFields = []
    let requiredIf = []
    let requiredSometimes = [] //if set, then don't remove it from the data.
    let optionals = [] //the optional fields apart from the requiredFields.
    switch (this.state.view) {
      case "Home":
        requiredFields = []
        optionals = ["search"]
        requiredIf = []
        requiredSometimes = []
        break;
      default:
        break;
    }
    requiredFields.forEach((element) => {
      if (this.state.data[element] === undefined || this.state.data[element].value === undefined) {
        //the field is not filled out
        if (print) {
          console.log("required not filled out: ", element)
        }
        valid = false
      }
    })
    requiredIf.forEach((condition) => {
      if (this.state.data[condition.field] === undefined || this.state.data[condition.field].value === undefined) {
        //the condition field is not filled out
        if (print) {
          console.log("condition field is not filled out: ", condition)
        }
        valid = false
      } else if (condition.values !== undefined && condition.values.includes(this.state.data[condition.field].value)) {
        //this field is required
        if (this.state.data[condition.require] === undefined || this.state.data[condition.require].value === undefined) {
          //and is not filled out
          if (print) {
            console.log("rif field is required and is not filled out: ", condition)
          }
          valid = false
        }
      } else if (condition.not !== undefined && !condition.not.includes(this.state.data[condition.field].value)) {
        //this field is required
        if (this.state.data[condition.require] === undefined || this.state.data[condition.require].value === undefined) {
          //and is not filled out
          if (print) {
            console.log("rif field is required with not and is not filled out: ", condition)
          }
          valid = false
        }
      }
    })
    //2) Make sure every data element is valid.
    for (let key in this.state.data) {
      let forget = false
      //Make sure it is not a requiredSometimes
      if (!requiredSometimes.includes(key)) {
        // Check the requiredIf conditions
        for (let i = 0; i < requiredIf.length; i = i + 1) {
          let rif = requiredIf[i]
          if (rif.require === key) {
            if (!rif.values.includes(this.state.data[rif.field].value)) {
              if (rif.not === undefined || rif.not.includes(this.state.data[rif.field].value)) {
                forget = true
              }
            }
            break
          }
        }
      }
      //Make sure this is a field we are looking for.
      if (optionals.includes(key) || requiredFields.includes(key)) {
        if (!forget && this.state.data[key].valid === false) {
          if (print) {
            console.log("data not valid", key)
          }
          valid = false
        }
      }
    }

    //3) If valid, return the data, else force check the fields for display.
    if (valid) {
      let data = {}
      for (let key in this.state.data) {
        let forget = false
        //Make sure it is not a requiredSometimes
        if (!requiredSometimes.includes(key)) {
          for (let i = 0; i < requiredIf.length; i = i + 1) {
            let rif = requiredIf[i]
            if (rif.require === key) {
              if (!rif.values.includes(this.state.data[rif.field].value)) {
                if (rif.not === undefined || rif.not.includes(this.state.data[rif.field].value)) {
                  forget = true
                }
              }
              break
            }
          }
        }
        if (!forget) {
          if (optionals.includes(key) || requiredFields.includes(key)) {
            if (this.state.data[key].value !== false && this.state.data[key].value.toString().length > 0) {
              data[key] = this.state.data[key].value
              if (typeof data[key] === 'string') {
                data[key] = data[key].trim()
              }
            }
          }
        }
      }
      return {
        valid: true,
        data: data
      }
    } else {
      return {
        valid: false,
        data: "Form not valid to submit"
      }
    }
  }

  /*
  * Called when data in an input form changes.
  * This will update the state.data param with the
  * name and new value of the form element.
  */
  formChanged(name, value, valid) {
    //console.log(name, value, valid);
    this.setState((prevState) => {
      let d = prevState.data
      d[name] = {
        value: value,
        valid: valid
      }
      if (prevState.view === "Create" && name === "type") {
        let defaults = Helpers.getScrapingConfigs(value)
        //select the first default.
        let config = defaults[0]
        for (let key in config) {
          d[key] = {
            value: config[key],
            valid: true
          }
        }
      } else if (prevState.view === "Create" && name === "config") {
        //get the config
        let defaults = Helpers.getScrapingConfigs(d["type"]["value"])
        let config = false
        for (let i = 0; i < defaults.length; i = i + 1) {
          if (defaults[i]["config"] === value) {
            config = defaults[i]
            break
          }
        }
        if (config !== false) {
          for (let key in config) {
            d[key] = {
              value: config[key],
              valid: true
            }
          }
        }
      }
      return {
        data: d,
        forceCheck: false,
        changesMade: true,
      }
    }, () => {
      //check to see if the form is valid to submit
      let res = this.checkForm()
      this.setState({
        valid: res.valid
      })
    })
  }

  /*
  Shakes the button and then removes the class.
  */
  shakeTheButton() {
    this.setState({
      shakeButton: true
    }, () => {
      setTimeout(() => {
        this.setState({
          shakeButton: false
        })
      }, 1000)
    })
  }

  /*
  We have selected an dispute.
  */
  disputeSelected(disputeID, clickType, event) {
    //go to this web scraping's page.
    if (clickType === "rightclick") {
      //open a new tab
      event.preventDefault()
      console.log(disputeID, clickType, event)
      window.open("/dispute/" + disputeID, "_blank", "noreferrer")
    } else {
      //go to this dispute's page
      this.props.changeView("ManageDispute", disputeID, this.state.sandbox)
    }
  }

  /*
  Changes the filter that is applied to the requests.
  */
  changeFilter(newFilter) {
    this.setState({
      filter: newFilter,
      nextDispute: false,
      page: 0,
    }, () => {
      this.getDisputes()
    })
  }

  /*
  Changes the page of results we are viewing.
  */
  changePage(newPage) {
    this.setState({
      page: newPage
    }, () => {
      this.getDisputes()
    })
  }

  /*
  Changes the sort that is applied to the requests.
  */
  changeSort(newSort) {
    if (!["Title", "Author", "Created", "Published"].includes(newSort)) {
      console.log("No Sort for ", newSort)
      return
    }
    this.setState((oldState) => {
      let newSortDirection = "DESC"
      if (oldState.sort === newSort) {
        //switch the direction
        newSortDirection = oldState.sortDirection
        if (newSortDirection === "DESC") {
          newSortDirection = "ASC"
        } else {
          newSortDirection = "DESC"
        }
      }
      return {
        sort: newSort,
        sortDirection: newSortDirection,
        page: 0,
        nextDispute: false,
      }
    }, () => {
      this.getDisputes()
    })
  }

  /*
  Changes the search that is applied to the requests.
  */
  changeSearch(data) {
    console.log(data)
    this.setState(() => {
      return {
        search: data.search || "",
        page: 0
      }
    }, () => {
      this.getDisputes()
    })
  }

  /*
  Get the list of disputes.
  */
  getDisputes() {
    this.setState({
      loading: true
    }, () => {

      let data = {
        sandbox: this.state.sandbox === true ? 1 : 0,
        needsResponse: this.state.needsResponse === true ? 1 : 0,
        limit: this.state.limit,
        //filter: this.state.filter,
        //sort: this.state.sort,
        //sortDirection: this.state.sortDirection,
        //limit: this.state.limit,
        //page: this.state.page,
        //positiveBalance: this.state.positiveBalance === true ? 1 : 0,
      }
      if (this.state.nextDispute !== false) {
        data.nextDispute = this.state.nextDispute
      }
      if (this.state.search.length > 0) {
        data.search = this.state.search
      }
      console.log("search data", data)

      API.callDarwinAPI("GET", "disputes", data, async (result) => {
        console.log("disputes", result)
        if ("error" in result) {
          //Change the view to 404
          this.props.showPopup("Error", "Couldn't get the disputes", "Please try again. If this continues to occur, reach out to support@geoji.com")
          this.setState({
            loading: false
          })
          return
        }
        let pageMax = this.state.page + (result.data.disputes.has_more ? 1 : 0)

        //format the disputes
        let uu = result.data.disputes.data
        for (let i = 0; i < uu.length; i = i + 1) {
          uu[i].money = uu[i].amount / 100.0
          uu[i].creationDate = Helpers.formatTimestampShort(uu[i].created)
          uu[i].due = (uu[i].evidence_details && uu[i].evidence_details.due_by) ? Helpers.formatTimestampShort(uu[i].evidence_details.due_by) : "Draft"
        }
        let nextDispute = false
        if (uu.length > 0 && result.data.disputes.has_more) {
          nextDispute = uu[uu.length - 1].id
        }
        this.setState({
          loading: false,
          disputes: uu,
          pageMax: pageMax,
          resultsCount: result.data.disputes.count,
          nextDispute: nextDispute,
        })
      })
    })
  }

  /*
  Changes the toggle for one of the filters and the re-searches for users.
  */
  onToggle(key) {
    this.setState((old) => {
      let obj = {}
      obj[key] = !old[key]
      console.log("obj", obj)
      if (key === "positiveBalance") {
        if (obj[key] === false) {
          //revert sort to the name field.
          obj.sort = "Title"
          obj.sortDirection = "ASC"
        } /*else {
          obj.sort = "Balance"
          obj.sortDirection = "DESC"
        }*/
      }
      old.nextDispute = false
      return obj
    }, () => {
      this.getDisputes()
    })
  }

  render() {

    return (
      <div className="WebScrapings">
        {/* Manage Disputes */}
        { this.state.view === "Home" && this.props.userInfo && this.props.userInfo.user &&
          <div className="FormBlock">
            <div className="WebScrapingsTitle">
              Disputes
            </div>
            { this.state.loading &&
              <div className="FormLoader" style={{height:"168px"}}>
                <Components.LoadingIndicator color="dark" />
              </div>
            }
            { !this.state.loading &&
              <div className="WebScrapingsContent">
                {/*<div className="InputDiv">
                  <Components.InputBottomLine type="text" name="search" placeholder="" validation="text" required="false"
                    title="Search by dispute ..." maximum={100}
                    value={this.state.data.search ? this.state.data.search.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
                </div>*/}
                {/* Filters, not in use right now. */}
                {<div className="WebScrapingsFilters">
                  <Components.SettingsToggle name="Sandbox" value={this.state.sandbox === true} onToggle={this.onToggle.bind(this, "sandbox")} />
                  <Components.SettingsToggle name="Needs Response" value={this.state.needsResponse === true} onToggle={this.onToggle.bind(this, "needsResponse")} />
                </div>}
                <Components.Table
                  tableInfo={Helpers.getManageDisputesTableInfo(this.state.disputes)}
                  noData={Helpers.getText("emptyDisputes")}
                  data={this.state.disputes}
                  onClick={this.disputeSelected}
                  onClickKey={"id"}
                  onHeaderClick={this.changeSort}
                  sort={this.state.sort}
                  sortDirection={this.state.sortDirection}
                  >
                  <div className="TableTop">
                    <div className="TableTopDate">
                      <Components.PageIndicator page={this.state.page} pageMax={this.state.pageMax} pageSelected={this.changePage} count={this.state.resultsCount} />
                    </div>
                  </div>
                </Components.Table>
              </div>
            }
          </div>
        }
      </div>
    )
  }
}

export class ManageDispute extends React.Component {

  constructor(props) {
    super(props)

    let data = {}
    console.log(this.props)

    this.state = {
      loading: false,
      data: data,
      forceCheck: false,
      shakeButton: false,
      changesMade: false, //have any changes been made

      view: "Home",
      subview: "Home",
      prompt: false,

      dispute: false,
    }

    autoBind(this)
  }

  componentDidMount() {
    //calculate the view
    this.calculateView()
  }

  componentDidUpdate(prevProps) {
    if (this.props.render !== prevProps.render) {
      //reload the home view.
      this.calculateView()
    }
  }

  calculateView() {
    //set the data
    if (this.state.view === "Home") {
      //load the abilities for this user.
      this.getDispute()
    }
  }

  /*
  * Submits the form
  */
  submitForm() {
    let results = this.checkForm(true)
    if (results.valid) {
      switch (this.state.view) {
        case "Home":
          //this.saveArticleSettings(results.data)
          break;
        default:
          console.error("Unhandled submitForm", this.state.view)
          break;
      }
    } else {
      console.log("Form not valid to submit")
      this.setState({
        forceCheck: true
      })
      //Shake the submit button as it is invalid to submit
      this.shakeTheButton()
    }
  }

  /*
  Checks the form to make sure it is valid.
  Returns {valid:Bool, data:{}}
  */
  checkForm(print = false) {
    //1) Make sure we have all of the data.
    let valid = true
    let requiredFields = []
    let requiredIf = []
    let requiredSometimes = [] //if set, then don't remove it from the data.
    let optionals = [] //the optional fields apart from the requiredFields.
    switch (this.state.view) {
      case "Home":
        requiredFields = ["title", "url", "subtitle"]
        optionals = ["imageURL"]
        requiredIf = []
        requiredSometimes = []
        break;
      default:
        break;
    }
    requiredFields.forEach((element) => {
      if (this.state.data[element] === undefined || this.state.data[element].value === undefined) {
        //the field is not filled out
        if (print) {
          console.log("required not filled out: ", element)
        }
        valid = false
      }
    })
    requiredIf.forEach((condition) => {
      if (this.state.data[condition.field] === undefined || this.state.data[condition.field].value === undefined) {
        //the condition field is not filled out
        if (print) {
          console.log("condition field is not filled out: ", condition)
        }
        valid = false
      } else if (condition.values !== undefined && condition.values.includes(this.state.data[condition.field].value)) {
        //this field is required
        if (this.state.data[condition.require] === undefined || this.state.data[condition.require].value === undefined) {
          //and is not filled out
          if (print) {
            console.log("rif field is required and is not filled out: ", condition)
          }
          valid = false
        }
      } else if (condition.not !== undefined && !condition.not.includes(this.state.data[condition.field].value)) {
        //this field is required
        if (this.state.data[condition.require] === undefined || this.state.data[condition.require].value === undefined) {
          //and is not filled out
          if (print) {
            console.log("rif field is required with not and is not filled out: ", condition)
          }
          valid = false
        }
      }
    })
    //2) Make sure every data element is valid.
    for (let key in this.state.data) {
      let forget = false
      //Make sure it is not a requiredSometimes
      if (!requiredSometimes.includes(key)) {
        // Check the requiredIf conditions
        for (let i = 0; i < requiredIf.length; i = i + 1) {
          let rif = requiredIf[i]
          if (rif.require === key) {
            if (!rif.values.includes(this.state.data[rif.field].value)) {
              if (rif.not === undefined || rif.not.includes(this.state.data[rif.field].value)) {
                forget = true
              }
            }
            break
          }
        }
      }
      //Make sure this is a field we are looking for.
      if (optionals.includes(key) || requiredFields.includes(key)) {
        if (!forget && this.state.data[key].valid === false) {
          if (print) {
            console.log("data not valid", key)
          }
          valid = false
        }
      }
    }

    //3) If valid, return the data, else force check the fields for display.
    if (valid) {
      let data = {}
      for (let key in this.state.data) {
        let forget = false
        //Make sure it is not a requiredSometimes
        if (!requiredSometimes.includes(key)) {
          for (let i = 0; i < requiredIf.length; i = i + 1) {
            let rif = requiredIf[i]
            if (rif.require === key) {
              if (!rif.values.includes(this.state.data[rif.field].value)) {
                if (rif.not === undefined || rif.not.includes(this.state.data[rif.field].value)) {
                  forget = true
                }
              }
              break
            }
          }
        }
        if (!forget) {
          if (optionals.includes(key) || requiredFields.includes(key)) {
            //console.log("value", this.state.data[key])
            if ((this.state.data[key].value !== false && this.state.data[key].value !== null) && this.state.data[key].value.toString().length > 0) {
              data[key] = this.state.data[key].value
              if (typeof data[key] === 'string') {
                data[key] = data[key].trim()
              }
            }
          }
        }
      }
      return {
        valid: true,
        data: data
      }
    } else {
      return {
        valid: false,
        data: "Form not valid to submit"
      }
    }
  }

  /*
  * Called when data in an input form changes.
  * This will update the state.data param with the
  * name and new value of the form element.
  */
  formChanged(name, value, valid) {
    this.setState((prevState) => {
      let d = prevState.data
      d[name] = {
        value: value,
        valid: valid
      }
      //check to see if the form is valid to submit
      return {
        data: d,
        forceCheck: false,
        changesMade: true,
      }
    }, () => {
      //check to see if the form is valid to submit
      let res = this.checkForm()
      this.setState({
        valid: res.valid
      }, () => {
        /*if (name === "title" || name === "details") {
          this.searchEmojis()
        } else if (name === "emoji") {
          this.searchLikeEmojis()
        }*/
      })
    })
  }

  /*
  Shakes the button and then removes the class.
  */
  shakeTheButton() {
    this.setState({
      shakeButton: true
    }, () => {
      setTimeout(() => {
        this.setState({
          shakeButton: false
        })
      }, 1000)
    })
  }

  /*
  Get the dispute.
  */
  getDispute() {
    this.setState({
      loading: true
    }, () => {
      let data = {
        sandbox: this.props.sandbox === true ? 1 : 0
      }
      console.log("Sandbox", this.props.fourthView, this.props.sandbox)
      API.callDarwinAPI("GET", "dispute/" + this.props.tertiaryView, data, async (result) => {
        //console.log("dispute/" + this.props.tertiaryView, result)
        if ("error" in result) {
          //Change the view to 404
          this.props.showPopup("Error", "Couldn't get the dispute", "Please try again. If this continues to occur, reach out to support@geoji.com")
          this.setState({
            loading: false
          })
          return
        }
        let newDispute = result.data.dispute
        //format the Dispute
        newDispute.dispute.money = newDispute.dispute.amount / 100.0
        newDispute.dispute.creationDate = Helpers.formatTimestampShort(newDispute.dispute.created)
        newDispute.dispute.due = (newDispute.dispute.evidence_details && newDispute.dispute.evidence_details.due_by) ? Helpers.formatTimestampShort(newDispute.dispute.evidence_details.due_by) : "Draft"

        console.log("dispute", newDispute)
        this.setState({
          loading: false,
          dispute: newDispute,
        })
      })
    })
  }

  openLink(link) {

    window.open(link, "_blank").focus()
  }

  updateDisputeData() {
    this.setState({
      loading: true
    }, () => {
      let data = {
        sandbox: this.props.sandbox === true ? 1 : 0
      }
      API.callDarwinAPI("PUT", "dispute/" + this.props.tertiaryView, data, async (result) => {
        console.log("PUT dispute/" + this.props.tertiaryView, result)
        if ("error" in result) {
          //Change the view to 404
          this.props.showPopup("Error", "Couldn't update the dispute data", "Please try again. If this continues to occur, reach out to support@geoji.com")
          this.setState({
            loading: false
          })
          return
        }
        console.log("Receipt: ", result.data.receipt)
        this.setState({
          loading: false,
        })
      })
    })
  }

  render() {

    return (
      <div className="ManageDispute">
        {/* Manage Dispute */}
        { this.state.view === "Home" && this.props.userInfo && this.props.userInfo.user &&
          <div className="FormBlock">
            <div className="ManageDisputeTitle">
              <Components.DualImage image={ImageClose} onClick={this.props.changeView.bind(this, "ManageDisputes")} />
              Dispute
            </div>
            { this.state.loading &&
              <div className="FormLoader" style={{height:"168px"}}>
                <Components.LoadingIndicator color="dark" />
              </div>
            }
            { !this.state.loading && this.state.dispute &&
              <div className="ManageDisputeContent">
                <div className="ManageDisputeContentSplit">
                  <div className="ManageDisputeContentSplitLeft">
                    {/* Dispute Information */}
                    <div className="ManageDisputeContentSubTitle">
                      Dispute Info
                    </div>
                    <div className="ManageDisputeContentSubpanel">
                      <div className="ManageDisputeContentSubpanelKey">
                        Reason
                      </div>
                      <div className="ManageDisputeContentSubpanelValue ManageDisputeContentSubpanelValueTheme">
                        {this.state.dispute.dispute.reason}
                      </div>
                      <div className="ManageDisputeContentSubpanelKey">
                        Status
                      </div>
                      <div className="ManageDisputeContentSubpanelValue ManageDisputeContentSubpanelValueTheme">
                        {this.state.dispute.dispute.status}
                      </div>
                      <div className="ManageDisputeContentSubpanelKey">
                        Disputed Amount
                      </div>
                      <div className="ManageDisputeContentSubpanelValue">
                        ${this.state.dispute.dispute.money}
                      </div>
                      <div className="ManageDisputeContentSubpanelKey">
                        Dispute Date
                      </div>
                      <div className="ManageDisputeContentSubpanelValue">
                        {this.state.dispute.dispute.creationDate}
                      </div>
                      <div className="ManageDisputeContentSubpanelKey">
                        Due Date
                      </div>
                      <div className="ManageDisputeContentSubpanelValue">
                        {this.state.dispute.dispute.due}
                      </div>
                      { this.state.dispute.dispute.evidence && this.state.dispute.dispute.evidence.service_date &&
                        <span>
                          <div className="ManageDisputeContentSubpanelKey">
                            Service Date
                          </div>
                          <div className="ManageDisputeContentSubpanelValue">
                            {this.state.dispute.dispute.evidence.service_date}
                          </div>
                        </span>
                      }
                    </div>

                    {/* Purchase & Redemption Information */}
                    <div className="ManageDisputeContentSubTitle">
                      Purchase Info
                    </div>
                    <div className="ManageDisputeContentSubpanel">
                      <div className="ManageDisputeContentSubpanelLink" onClick={this.openLink.bind(this, this.state.dispute.purchaseLink)}>
                        Open Purchase
                      </div>
                      <div className="ManageDisputeContentSubpanelKey">
                        Status
                      </div>
                      <div className="ManageDisputeContentSubpanelValue ManageDisputeContentSubpanelValueTheme">
                        {this.state.dispute.purchase.status}
                      </div>
                      <div className="ManageDisputeContentSubpanelKey">
                        Redemption
                      </div>
                      <div className="ManageDisputeContentSubpanelValue ManageDisputeContentSubpanelValueTheme">
                        { this.state.dispute.purchase.redeemed === "1" ? "Redeemed" : "Unused" }
                      </div>
                      <div className="ManageDisputeContentSubpanelKey">
                        Charged Amount
                      </div>
                      <div className="ManageDisputeContentSubpanelValue">
                        ${ this.state.dispute.purchase.totalCents / 100.0 }
                      </div>
                      <div className="ManageDisputeContentSubpanelKey">
                        Description
                      </div>
                      <div className="ManageDisputeContentSubpanelValue">
                        {this.state.dispute.purchase.description}
                      </div>
                      <div className="ManageDisputeContentSubpanelKey">
                        Purchase Date
                      </div>
                      <div className="ManageDisputeContentSubpanelValue">
                        {Helpers.formatDateObjectLong(Helpers.parseSQLDate(this.state.dispute.purchase.purchaseTimestamp))}
                      </div>
                      { (this.state.dispute.purchase.cardLast4 || this.state.dispute.purchase.payPalOrderID || this.state.dispute.purchase.amazonChargeID) &&
                        <div className="ManageDisputeContentSubpanelKey">
                          Purchase Method
                        </div>
                      }
                      { this.state.dispute.purchase.cardLast4 &&
                        <div className="ManageDisputeContentSubpanelValue">
                          **** {this.state.dispute.purchase.cardLast4}
                        </div>
                      }
                      { !this.state.dispute.purchase.cardLast4 && this.state.dispute.purchase.payPalOrderID &&
                        <div className="ManageDisputeContentSubpanelValue">
                          PayPal Order {this.state.dispute.purchase.payPalOrderID}
                        </div>
                      }
                      { !this.state.dispute.purchase.cardLast4 && this.state.dispute.purchase.amazonChargeID &&
                        <div className="ManageDisputeContentSubpanelValue">
                          Amazon Charge {this.state.dispute.purchase.amazonChargeID}
                        </div>
                      }
                    </div>

                    {/* User  Information */}
                    <div className="ManageDisputeContentSubTitle">
                      User Info
                    </div>
                    { this.state.dispute.user.name === "Terminal Checkout" &&
                      <div className="ManageDisputeContentSubpanel">
                        <div className="ManageDisputeContentSubpanelKey">
                          Terminal Checkout
                        </div>
                        <div className="ManageDisputeContentSubpanelValue">
                          No information available about this user
                        </div>
                      </div>
                    }
                    { this.state.dispute.user.name !== "Terminal Checkout" &&
                      <div className="ManageDisputeContentSubpanel">
                        <div className="ManageDisputeContentSubpanelLink" onClick={this.openLink.bind(this, "/user/" + this.state.dispute.user.id)}>
                          Open User
                        </div>
                        <div className="ManageDisputeContentSubpanelKey">
                          Name
                        </div>
                        <div className="ManageDisputeContentSubpanelValue">
                          {this.state.dispute.user.name}
                        </div>
                        <div className="ManageDisputeContentSubpanelKey">
                          Phone Number
                        </div>
                        <div className="ManageDisputeContentSubpanelValue">
                          {Helpers.parsePhoneNumber(this.state.dispute.user.phoneNumber)}
                        </div>
                        <div className="ManageDisputeContentSubpanelKey">
                          Email
                        </div>
                        <div className="ManageDisputeContentSubpanelValue">
                          {this.state.dispute.user.email}
                        </div>
                        { this.state.dispute.user.address &&
                          <span>
                            <div className="ManageDisputeContentSubpanelKey">
                              Address
                            </div>
                            <div className="ManageDisputeContentSubpanelValue">
                              {this.state.dispute.user.address}
                            </div>
                          </span>
                        }
                      </div>
                    }

                    {/* Actions */}
                    { this.state.dispute.dispute.status === "needs_response" &&
                      <span>
                        <div className="ManageDisputeContentSubTitle">
                          Actions
                        </div>
                        <div className="ManageDisputeContentSubpanel">
                          <div className="ManageDisputeContentAction" onClick={this.updateDisputeData.bind(this)}>
                            Update Information
                          </div>
                        </div>
                      </span>
                    }
                  </div>

                  {/* Geoji iFrame */}
                  <div className="ManageDisputeContentSplitRight">
                    <div className="ManageDisputeContentSubTitle" onClick={this.openLink.bind(this, this.state.dispute.geojiLink)}>
                      Open Geoji
                    </div>
                    <iframe src={this.state.dispute.geojiLink} title="geoji" />
                  </div>
                </div>
              </div>
            }
            { !this.state.loading && !this.state.dispute &&
              <div className="ManageDisputeContent">
                <div className="ManageDisputeContentError">
                  We could not find this dispute
                </div>
              </div>
            }
          </div>
        }
      </div>
    )
  }
}
